const FUELS_KEYS = {
    M: 'Metano',
    G: 'Benzina',
    D: 'Diesel',
    EL: 'Elettrico',
    MHY: 'Mild Hybrid',
    PHY: 'Plug-In Hybrid',
    FH: 'Full Hybrid',
} as const

export type FuelCode = keyof typeof FUELS_KEYS

export default FUELS_KEYS
